export var SORT_BY_MAP = {
  updated_at: "recent",
  created_at: "created"
};
export var SORT_ORDER_MAP = {
  asc: "asc",
  desc: "desc"
};